import React from 'react';
import withEnterpriseLayout from 'src/components/AppRoutes/Enterprise/withEnterpriseLayout';
import EnterpriseMealCreditList from 'src/components/oneCorp/features/MealCredit/components/MealCreditList/EnterpriseMealCreditList';

const MealCreditListPageLayout = withEnterpriseLayout(EnterpriseMealCreditList);

export const MealCreditListRoute = (): JSX.Element => (
  <MealCreditListPageLayout pageTitle="Meal credits" useFluidContainer />
);
